import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VOverlay,[_c(VCard,{attrs:{"width":"300","color":"primary","dark":""}},[_c(VCardText,{staticClass:"text-subtitle-1"},[_vm._v(" Espera porfavor "),_c(VProgressLinear,{staticClass:"mb-0 mt-2",attrs:{"indeterminate":"","color":"white"}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }